import "@cyber-range/cyber-range-lib-ui/dist/style.css"

import { createApp } from 'vue'
import App from './App.vue'
import Config from './config';
import Router from './routers/router'
import { createPinia } from 'pinia';
import crUi from '@cyber-range/cyber-range-lib-ui';
import { createI18n } from 'vue-i18n'
import createMessages from "./strings/strings";
import { CrTheme } from "@cyber-range/cyber-range-lib-ui/dist_types/options/crTheme";
import InitialLoading from "./components/InitialLoading.vue";
import VueMatomo from 'vue-matomo';

const theme = 
{
    font: {
        family: "'Source Sans 3', sans-serif",
        size: '1rem',
    },
    colors: {
        splashBackground: '#020a24',
        splashGradient: '#123561',
        splashAccent: '#7cf4b4',
        splashAccentSubtle: '#7cf4b444',
        splashText: '#efefef',                    
        menuCardBackground: '#0c1a2e',
        menuCardBorder: '#1e3a5c',
        menuCardHover: '#112240',
        text: '#efefef',
        primaryButtonColor: '#7cf4b4',
        primaryButtonTextColor: '#123561',
        confirmationDialogConfirmBackgroundColor: '#7cf4b4',
        confirmationDialogConfirmTextColor: '#123561',
        errorTextColor: '#ff6f6f',
        inputFocusBoxShadowColor: '#7cf4b4',
        buttonFocusContrastColor: '#020a24',
        dialogBackgroundColor: '#0c1a2e',
        loadingSpinnerColor: '#7cf4b4',
        profileMenuBackground: '#0c1a2e',
        profileMenuAccent: '#7cf4b4',
        profileMenuText: '#ffffff',
        profileMenuBorder: '#1e3a5c',
        scoreBadgeText: '#000000',
        tableHeaderBackgroundColor: '#1f2c3f',
        tableBorderColor: '#162b47',
    },
    cssVariables: {
        backgroundGradient: 'linear-gradient(135deg, var(--cr-splash-background) 0%, var(--cr-splash-gradient) 60%, var(--cr-splash-background) 100%)',
        inputTextSize: '1.1rem',
        pillButtonBorderRadius: '999px',
        mainContentWidth: '900px',
    }
} as CrTheme

let pinia = createPinia();

// Initial loading doesn't use any custom strings, don't include createMessages() to avoid double-calculating
let i18n = createI18n({
    legacy: false,
    locale: 'en',
    missingWarn: false,
    warnHtmlMessage: false,
    globalInjection: false
})

// Show a initial loading while loading the real Vue app.
createApp(InitialLoading)
	.use(pinia)
	.use(i18n)
	.use(crUi, {theme})
	.mount('#app');

Config.load(`${window.location.protocol}//${window.location.hostname}:${window.location.port}/env.json`).then(() => {
    
    const matomo = {
        host: Config.MATOMO_BASE_URL,
        siteId: Config.MATOMO_SITE_ID,
        router: Router,
        enableLinkTracking: true,
        disableCookies: true,
        requireConsent: false,
        trackInitialView: true,
        enableHeartBeatTimer: true,
        trackSiteSearch: true,
    }

    // Recreate i18n with createMessages that uses env config
    i18n = createI18n({
        legacy: false,
        locale: 'en',
        missingWarn: false,
        warnHtmlMessage: false,
        messages: createMessages(),
        globalInjection: false
    })

    createApp(App)
        .use(pinia)
        .use(Router)
        .use(i18n)
        .use(crUi, {theme})
        .use(VueMatomo, matomo)
        .mount('#app')
});
